import { useQuery, UseQueryResult } from "react-query";

import { GET_CUSTOMER_PAST_CLINICIANS, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { getCustomerPastCliniciansAsync } from "api/customers";

interface PastClinician {
  id: number | string;
  first_name: string;
  last_name: string;
  switched_away?: string | null;
  [key: string]: any;
}

interface UseGetCustomerPastCliniciansReturn {
  pastClinicians: PastClinician[];
  pastCliniciansLoading: boolean;
  refetchPastClinicians: () => Promise<unknown>;
}

/**
 * Fetches prior clinicians for a given client.
 * @param clientId - The client ID.
 */
const useGetCustomerPastClinicians = (
  clientId?: string | number
): UseGetCustomerPastCliniciansReturn & Omit<UseQueryResult, "data" | "isLoading" | "refetch"> => {
  const { data, isLoading, refetch, ...rest } = useQuery(
    [GET_CUSTOMER_PAST_CLINICIANS, clientId],
    () => getCustomerPastCliniciansAsync(clientId),
    {
      enabled: Boolean(clientId),
      staleTime: STALE_TIME_5_MINUTES,
      retry: false,
    }
  );

  return {
    pastClinicians: data?.data || [],
    pastCliniciansLoading: isLoading,
    refetchPastClinicians: refetch,
    ...rest,
  };
};

export default useGetCustomerPastClinicians;
